import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getProjectDocumentWorkflowActionItems } from '../../api/project-document-workflows';
import { ProjectDocumentWorkflowMyTask } from '../ProjectDocumentWorkflow/projectDocumentWorkflowSlice';

export const getBellNotificationActionItemsAsync = createAsyncThunk(
  'bellNotifications/getBellNotificationActionItems',
  getProjectDocumentWorkflowActionItems
);

interface BellNotificationState {
  actionItems: {
    data: ProjectDocumentWorkflowMyTask[];
    count: number;
    countOnDue: number;
    countDelay: number;
  };
}

const initialState: BellNotificationState = {
  actionItems: {
    data: [],
    count: 0,
    countOnDue: 0,
    countDelay: 0
  }
};

export default createSlice({
  name: 'bellNotifications',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      getBellNotificationActionItemsAsync.fulfilled,
      (state, action) => {
        state.actionItems = action.payload;
      }
    );
  }
});
